var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"border-0",attrs:{"title":_vm.title}},_vm._l((_vm.project.submissions),function(submission,k){return _c('submission-review-card',{key:k,attrs:{"submission":submission,"managedLists":_vm.managedLists}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }